import React from 'react';

const HelpIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.36 7.96C13.36 9.05 12.69 9.63 12.05 10.2C11.52 10.67 11.02 11.1 10.89 11.8L10.85 12H9.1L9.13 11.72C9.27 10.55 9.93 9.96 10.6 9.45C11.12 9.05 11.61 8.68 11.61 7.96C11.61 7.45 11.38 6.99 10.98 6.67C10.58 6.36 10.06 6.25 9.56 6.38C8.97 6.53 8.51 7.05 8.37 7.72L8.32 8H6.57L6.63 7.58C6.83 6.18 7.78 5.05 9.05 4.71C10.1 4.42 11.19 4.63 12.03 5.28C12.88 5.92 13.36 6.9 13.36 7.96ZM10 16C10.55 16 11 15.55 11 15C11 14.45 10.55 14 10 14C9.45 14 9 14.45 9 15C9 15.55 9.45 16 10 16ZM10 1C5.04 1 1 5.04 1 10C1 14.96 5.04 19 10 19C14.96 19 19 14.96 19 10C19 5.04 14.96 1 10 1ZM10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10C0 4.48 4.48 0 10 0Z"
        fill="black"
      />
    </svg>
  );
};

export default HelpIcon;
